import Dot from 'components/Basic/Dot/Dot';
import { useTranslation } from 'react-i18next';
import { pitchTypeGroupToColor, pitchTypeToColor } from 'utilities/colorHelpers';

type Props = {
  pitchType: string;
};

const PitchTypeTableCell = ({ pitchType }: Props) => {
  const { t } = useTranslation();

  const color = pitchTypeToColor[pitchType] ?? pitchTypeGroupToColor[pitchType];

  if (color === undefined) {
    console.error(`PitchTypeCell: pitchType "${pitchType}" is not of type PitchType or PitchTypeGroup`);
  }

  return (
    <div className='flex-row items-center gap-1'>
      <Dot color={color} size='large' />
      {t(pitchType)}
    </div>
  );
};

export default PitchTypeTableCell;
